module.exports = __webpack_public_path__ + "static/img/delete_actived_icon.a5f2c617.svg";